
import { Skeleton } from "@/components/ui/skeleton";

const ProductsLoading = () => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
      {[...Array(8)].map((_, index) => (
        <div key={index} className="space-y-4">
          <Skeleton className="aspect-square w-full" />
          <Skeleton className="h-6 w-3/4" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-6 w-1/2" />
        </div>
      ))}
    </div>
  );
};

export default ProductsLoading;
